import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';

export const VariantWithStockInformationDTO = z.object({
    id: z.string(),
    isAvailable: z.boolean().nullish(),
    stock: z
        .object({
            warehouse: z
                .object({
                    status: z.string().nullish(),
                    deliveryMessage: z.string().nullish(),
                })
                .nullish(),
            store: z
                .object({
                    status: z.string().nullish(),
                    deliveryMessage: z.string().nullish(),
                })
                .nullish(),
        })
        .nullish(),
});

export type VariantWithStockInformationDTO = z.infer<typeof VariantWithStockInformationDTO>;

export const ProductStockInformationDTO = z.object({
    product: z.object({
        variants: DecoderHelpers.defaultArray(VariantWithStockInformationDTO),
    }),
});

export type ProductStockInformationDTO = z.infer<typeof ProductStockInformationDTO>;

export const ProductStockInformationWithUnknownDTO = z.object({
    product: z.object({
        variants: DecoderHelpers.defaultArray(z.unknown()),
    }),
});
